import React, { useState, useEffect, useRef } from 'react';
import { Grid, Row, Col, DropdownButton, Button, MenuItem, ButtonGroup, Modal, FormControl, FormGroup, Glyphicon, ControlLabel } from 'react-bootstrap';
import Request from 'superagent';

export default function SelectEvent({ userProfile, allowForNewEvent, configuredItemCount, newEventSelected }) {
    const outerRef = useRef(null);

    const [events, setEvents] = useState([]);
    const [eventName, setEventName] = useState('');
    const [currentEventID, setCurrentEventID] = useState(null);
    const [showCreateEvent, setShowCreateEvent] = useState(false);
    const [validationError, setValidationError] = useState(null);
    const [eventDeleted, setEventDeleted] = useState(false);
    const [eventButtonDisabled, setEventButtonDisabled] = useState(false);

    useEffect(() => {
        getAllEvents();
    }, []);

    function getAllEvents() {
        const jsonString = JSON.stringify(userProfile);
        const url = userProfile[0].serverIP + '/php/ob_clock.php?argument1=queryGetEvents&argument2=' + jsonString;
        Request.get(url).then((response) => {
            if (response.body[0].Result === 'OK') {
                const newEvents = [];
                response.body[0].data.forEach((row) => {
                    newEvents.push(<MenuItem key={row.event_id} eventKey={row.event_id}>{row.event_name}</MenuItem>);
                });
                if (allowForNewEvent) {
                    if (newEvents.length > 0) newEvents.push(<MenuItem divider key="divider" eventKey="divider" />);
                    newEvents.push(<MenuItem key="newmenuitem" eventKey="New">New Event</MenuItem>);
                }
                setEvents(newEvents);
            }
        });
    }

    function eventSelected(eventID) {
        if (eventID === 'New') {
            setEventName('');
            setShowCreateEvent(true);
        } else {
            setCurrentEventID(eventID);
            const eventsLength = allowForNewEvent ? events.length - 2 : events.length;
            for (let i = 0; i < eventsLength; i++) {
                if (events[i].props.eventKey === eventID) {
                    setEventName(events[i].props.children);
                    newEventSelected(eventID);
                    break;
                }
            }
        }
    }

    function saveNewEvent() {
        const eventsLength = allowForNewEvent ? events.length - 2 : events.length;
        for (let i = 0; i < eventsLength; i++) {
            if (events[i].props.children.toLowerCase() === eventName.toLowerCase()) {
                setValidationError('error');
                return;
            }
        }
        setShowCreateEvent(false);
        createEvent();
    }

    function createEvent() {
        const parameters = [{
            customer_id: userProfile[0].customer_id,
            site_id: userProfile[0].site_id,
            eventName,
        }];
        const url = userProfile[0].serverIP + '/php/ob_clock.php?argument1=createEvent&argument2=' + JSON.stringify(parameters);
        Request.get(url).then((response) => {
            if (response.body[0].Result === 'OK') {
                const newID = response.body[0].data[0].event_id;
                setCurrentEventID(newID);
                newEventSelected(newID);
                getAllEvents();
            }
        });
    }

    function deleteEvent() {
        const url = userProfile[0].serverIP + '/php/ob_clock.php?argument1=deleteEvent&argument2=' + JSON.stringify([{ event_id: currentEventID }]);
        Request.get(url).then((response) => {
            if (response.body[0].Result === 'OK') {
                getAllEvents();
                setCurrentEventID(0);
                newEventSelected(0);
                setEventName(prev => prev + ' Deleted');
                setEventDeleted(true);
                setTimeout(() => {
                    setEventName('');
                    setEventDeleted(false);
                }, 1200);
            }
        });
    }

    let deleteEventEl = null;
    if (configuredItemCount === 0 && eventName !== '' && outerRef.current) {
        const lineHeight = outerRef.current.parentElement.offsetHeight + 'px';
        deleteEventEl = (
            <Glyphicon key="delete"
                onClick={deleteEvent}
                className="cog"
                style={{ color: 'red', lineHeight, textAlign: 'center', height: lineHeight }}
                bsSize="large"
                glyph="remove" />
        );
    }

    const errorMsgStyle = { display: validationError === 'error' ? 'block' : 'none', color: 'red', position: 'absolute', left: '15px' };
    const colRightStyle = allowForNewEvent ? { paddingRight: 0 } : {};

    return (
        <div ref={outerRef}>
            <Modal show={showCreateEvent} autoFocus={true} onHide={() => setShowCreateEvent(false)}>
                <Modal.Header>
                    <Modal.Title>Create Event</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Grid>
                        <Row>
                            <FormGroup controlId="formValidationError1" validationState={validationError}>
                                <ControlLabel>New Event Name</ControlLabel>
                                <FormControl type="text"
                                    autoFocus={true}
                                    className="form-control input-md"
                                    name="newEventName"
                                    value={eventName}
                                    onChange={(e) => setEventName(e.target.value)}
                                    onKeyPress={(e) => { if (e.key === 'Enter') saveNewEvent(); }}
                                    placeholder="New name"
                                    style={{ width: '100%' }} />
                            </FormGroup>
                        </Row>
                    </Grid>
                    <span style={errorMsgStyle}><br />Event name already exists</span>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary" disabled={eventName.length === 0} onClick={saveNewEvent}>Save</Button>
                    <Button bsStyle="danger" onClick={() => setShowCreateEvent(false)}>Cancel</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={eventDeleted} onHide={() => setEventDeleted(false)}>
                <Modal.Body>
                    <span style={{ color: 'red' }}>{eventName}</span>
                </Modal.Body>
            </Modal>
            <Col xs={3} sm={2} md={2} lg={1} style={{ paddingRight: 0 }}>
                <ButtonGroup justified>
                    <DropdownButton
                        bsStyle="primary"
                        title="Event"
                        key="dropdownkey"
                        id="dropdown-event"
                        onSelect={eventSelected}
                        disabled={eventButtonDisabled}>
                        {events}
                    </DropdownButton>
                </ButtonGroup>
            </Col>
            <Col xs={6} sm={4} md={4} lg={4} style={colRightStyle}>
                <input type="text"
                    className="form-control input-md"
                    name="eventName"
                    value={eventName}
                    placeholder="Event Name"
                    style={{ width: '100%' }}
                    disabled={true} />
            </Col>
            <Col xs={1} sm={1} md={1} lg={1}>{deleteEventEl}</Col>
        </div>
    );
}
